import {Injectable} from '@angular/core';
import {AbstractModelService} from "../../model/abstract-model.service";
import {ApiClientService} from "../../api-client/api-client.service";
import {Activity} from '../../../models/crm/activity';
import {Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ActivityService extends AbstractModelService<Activity> {

  activitySubject = new Subject<void>();

  constructor(apiClient: ApiClientService) {
    super(apiClient, '/crm/activity', Activity);
  }
}
